import reduce from 'lodash/reduce';

export type PopupOptions = {
  width?: number;
  height?: number;
  toolbar?: boolean;
  location?: boolean;
  directories?: boolean;
  status?: boolean;
  menubar?: boolean;
  scrollbars?: boolean;
  resizable?: boolean;
  copyhistory?: boolean;
};

const defaultPopupOptions: PopupOptions = {
  width: 600,
  height: 600,
  toolbar: false,
  location: false,
  directories: false,
  status: false,
  menubar: false,
  scrollbars: false,
  resizable: false,
  copyhistory: false,
};

type PopupLayoutPosition = {
  left: number;
  top: number;
};

function getPopupPosition(width: number, height: number): PopupLayoutPosition {
  const screenLeft =
    window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const screenTop =
    window.screenTop !== undefined ? window.screenTop : window.screenY;

  const menuHeight = window.outerHeight - window.innerHeight;

  return {
    left: window.innerWidth / 2 - width / 2 + screenLeft,
    top: window.innerHeight / 2 - height / 2 + screenTop + menuHeight,
  };
}

export function openPopup(url: string, inputOptions: PopupOptions = {}) {
  let options: PopupOptions = {
    ...defaultPopupOptions,
    ...inputOptions,
  };

  options = reduce(
    options,
    (acc, value, key) => {
      return {
        ...acc,
        // eslint-disable-next-line no-nested-ternary
        [key]: typeof value !== 'boolean' ? value : value ? 'yes' : 'no',
      };
    },
    {}
  );

  if (options.width && options.height) {
    options = {
      ...options,
      ...getPopupPosition(options.width, options.height),
    };
  }

  const optionsString: string = reduce(
    // @ts-ignore
    options,
    (acc, value, key) => [...acc, `${key}=${value}`],
    []
  ).join(', ');

  return window.open(url, '', optionsString);
}
